import React, { useRef } from "react";
import Header from "../components/site/Header";
import Hero from "../components/site/Hero";
import Stats from "../components/site/Stats";
import Timeline from "../components/site/Timeline";
import BuiltForBharat from "../components/site/BuiltForBharat";
import BeforeAfter from "../components/site/BeforeAfter";
import AIRobotGuide from "../components/site/AIRobotGuide";
import Features from "../components/site/Features";
import WhyUs from "../components/site/WhyUs";
import Testimonials from "../components/site/Testimonials";
import FAQ from "../components/site/FAQ";
import LeadForm from "../components/site/LeadForm";
import Footer from "../components/site/Footer";
import WhatsAppButton from "../components/site/WhatsAppButton";
import AIChatWidget from "../components/site/AIChatWidget";
import CustomCursor from "../components/site/CustomCursor";

const WHATSAPP_NUMBER = "919141302057";
const WHATSAPP_HREF = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Hi Digital Onboarding team, I want to bring my business online."
)}`;

export default function Landing() {
  const formRef = useRef(null);
  const chatRef = useRef(null);

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const openChat = () => chatRef.current?.open();

  return (
    <div className="relative bg-[#05060F] text-white overflow-x-hidden" data-testid="landing-page">
      <CustomCursor />
      <Header onCtaClick={scrollToForm} />
      <main>
        <Hero onPrimaryCta={scrollToForm} onChatCta={openChat} />
        <Stats />
        <Timeline onCta={scrollToForm} />
        <BuiltForBharat onCta={scrollToForm} />
        <BeforeAfter onCta={scrollToForm} />
        <AIRobotGuide onCta={scrollToForm} />
        <Features />
        <WhyUs onCta={scrollToForm} whatsappHref={WHATSAPP_HREF} />
        <Testimonials />
        <FAQ />
        <LeadForm formRef={formRef} />
      </main>
      <Footer />
      <WhatsAppButton href={WHATSAPP_HREF} />
      <AIChatWidget ref={chatRef} />
    </div>
  );
}
